import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import noop from 'lodash/noop';

import { ForSaleCategory } from 'Types/enquiryStates';
import type { Vehicle } from 'Types/vehicle';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

type UseIsBinVehicleProcessingParams = {
	expiryDate: Vehicle['expiryDate'];
	slug: Vehicle['state']['slug'];
};

export const useIsBinVehicleProcessing = ({ expiryDate = '', slug }: UseIsBinVehicleProcessingParams): boolean => {
	const [isBinVehicleExpired, setIsBinVehicleExpired] = useState(false);
	const isBinExpiryVisibilityEnabled = useFeatureToggle(FEATURES.binExpiryVisibility);
	const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

	useEffect(() => {
		const timeTillExpiry = dayjs(expiryDate).diff(dayjs());
		const isExpired = Boolean(expiryDate) && timeTillExpiry <= 0;

		clearTimeout(timeoutRef.current);
		setIsBinVehicleExpired(isExpired);

		if (!isBinExpiryVisibilityEnabled || isExpired || !expiryDate) {
			return noop;
		}

		timeoutRef.current = setTimeout(() => {
			setIsBinVehicleExpired(true);
		}, timeTillExpiry);

		return () => {
			clearTimeout(timeoutRef.current);
		};
	}, [expiryDate, isBinExpiryVisibilityEnabled]);

	return isBinExpiryVisibilityEnabled && slug === ForSaleCategory.forSale && isBinVehicleExpired;
};
